import { render, staticRenderFns } from "./SuccessTrainingList.vue?vue&type=template&id=131b2b6d&"
import script from "./SuccessTrainingList.vue?vue&type=script&lang=js&"
export * from "./SuccessTrainingList.vue?vue&type=script&lang=js&"
import style0 from "./SuccessTrainingList.vue?vue&type=style&index=0&id=131b2b6d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports